import { memo } from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import ValuePropositionItems from './ValuePropositionItems'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import useValuePropositionItems from './useValuePropositionItems'

const StyledLayoutContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function ValuePropositionBanner() {
  const intl = useIntl()
  const values = useValuePropositionItems()

  return (
    <Pane>
      <StyledLayoutContainer>
        <VerticalSpacer gap={40}>
          <Heading variant="heading2">{intl.formatMessage({
            id: '7ztxy0ldQzJhMPjI5Ks-',
            defaultMessage: 'Why you should book with us',
            description: 'Section heading for value proposition banner section',
          })}
          </Heading>
          <ValuePropositionItems values={values} />
        </VerticalSpacer>
      </StyledLayoutContainer>
    </Pane>
  )
}

export default memo(ValuePropositionBanner)
